import { CoreTagsByIdName } from './name';
import { coreTagsUpdateSyncSlice } from '../update';
import { patchTag } from '@api';
import { updateTagReferences } from '../_idMap/actions';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPutAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTagsByIdPutAsyncSlice = createPutAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.TAG_UPDATED, (action) => ({
				sonarObjectTagId: action.data.id
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => updateTagReferences([ request ]),
			coreTagsUpdateSyncSlice.syncActionCreator
		]
	},
	name: CoreTagsByIdName,
	receive: false,
	request: true,
	requestHandler: patchTag
});
